import { render, staticRenderFns } from "./Tender.vue?vue&type=template&id=c6004d68&scoped=true&"
import script from "./Tender.vue?vue&type=script&lang=js&"
export * from "./Tender.vue?vue&type=script&lang=js&"
import style0 from "./Tender.vue?vue&type=style&index=0&id=c6004d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6004d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6004d68')) {
      api.createRecord('c6004d68', component.options)
    } else {
      api.reload('c6004d68', component.options)
    }
    module.hot.accept("./Tender.vue?vue&type=template&id=c6004d68&scoped=true&", function () {
      api.rerender('c6004d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/detail/Tender.vue"
export default component.exports